<template>
<div>
   <!-- 对话框 -->
    <a-modal
      title="简历确认"
      :visible="showVisible"
      okText="下一步"
      :footer="null"
      @cancel="cancel"
      class="modals"
      :dialogStyle="dialogStyle"
    >
    <div class="bigBox">
      <!-- 第一步人员基本情况 -->
      <div v-show="step==1">

        <!-- 上方标题 -->
        <div style="backgroundColor:white;overflow:hidden">
          <div class="ryjbxxTitle">人员基本信息</div>
        </div>
        <!-- 下方内容 -->
        <div class="messages">
        
          <a-form-model ref="baseRef" :rules="baseRules" :model="BasicsInfo" :label-col="labelCol" :wrapper-col="wrapperCol">

            <a-row>
              <a-col :span="12">
                <a-form-model-item label="是否服从调剂">
                 <a-checkbox-group v-model="BasicsInfo.a0187">
                   <a-checkbox value="1" name="type">
                      
                   </a-checkbox>
                  </a-checkbox-group>
                </a-form-model-item>
              </a-col>

              <a-col :span="9">
                <a-form-model-item label="考试地点" prop="a0185">
                  <a-select allowClear  v-model="BasicsInfo.a0185" style="width: 200px" placeholder="请选择">
                  <a-select-option v-for="item in places" :key="item.PLACEID" :value="item.PLACEID">{{item.EXAMADRESS}}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>


            <a-row>
             <a-col :span="12">
              <a-form-model-item label="姓名" prop="a0101">
              <a-input :maxLength="20" v-model="BasicsInfo.a0101" style="width: 200px"></a-input>
              </a-form-model-item>
             </a-col>

              <a-col :span="9">
                <a-form-model-item label="性别" prop="a0104">
                 <a-select allowClear  v-model="BasicsInfo.a0104" style="width: 200px">
                  <a-select-option v-for="(item,i) in sexList" :key="i" :label="item.DMCOD" :value="item.DMCOD">{{item.DMCPT}}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
             <a-col :span="12">
              <a-form-model-item label="民族" prop="a0117">
               <a-select allowClear  v-model="BasicsInfo.a0117" style="width: 200px">
                  <a-select-option v-for="(item,i) in nations" :key="i" :label="item.DMCOD" :value="item.DMCOD">{{item.DMCPT}}</a-select-option>
                </a-select>
              </a-form-model-item>
             </a-col>

              <a-col :span="9">
                <a-form-model-item label="政治面貌" prop="a0141">
                 <a-select allowClear  v-model="BasicsInfo.a0141 " style="width: 200px">
                  <a-select-option v-for="(item,i) in Political" :key="i" :label="item.DMCOD" :value="item.DMCOD">{{item.DMCPT}}</a-select-option>
                 </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>


            <a-row>
             <a-col :span="12">
               <a-form-model-item label="出生日期" prop="a0107">
                 <a-date-picker :inputReadOnly="true" placeholder="出生日期" show-tiem type="date"  v-model="BasicsInfo.a0107" style="width: 200px"></a-date-picker>
               </a-form-model-item>
             </a-col>

              <a-col :span="9">
                <a-form-model-item label="身高" prop="a0108">
                  <a-input :maxLength="6" @keyup.native="proving2($event)" onkeyup = "value=value.replace(/[\u4e00-\u9fa5/\s+/]/ig,'')" v-model="BasicsInfo.a0108" style="width: 200px"></a-input>
                  <span class="cm">cm</span>
                </a-form-model-item>
              </a-col>
            </a-row>


            <a-row>
             <a-col :span="12">
               <a-form-model-item label="体重" prop="a01101">
                  <a-input :maxLength="6" @keyup.native="proving2($event)" onkeyup = "value=value.replace(/[\u4e00-\u9fa5/\s+/]/ig,'')" v-model="BasicsInfo.a01101" style="width: 200px"></a-input>
                  <span class="kg">kg</span>
                </a-form-model-item>
             </a-col>

              <a-col :span="9">
                <a-form-model-item label="婚姻状态" prop="a0131">
                 <a-select allowClear  v-model="BasicsInfo.a0131 " style="width: 200px">
                  <a-select-option v-for="(item,i) in marriage" :key="i" :label="item.DMCOD" :value="item.DMCOD">{{item.DMCPT}}</a-select-option>
                 </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>


             <a-row>
             <a-col :span="12">
               <a-form-model-item label="身份证号" prop="a0184">
                  <a-input :maxLength="25" @keyup.native="proving2($event)" v-model="BasicsInfo.a0184" style="width: 200px"></a-input>
                </a-form-model-item>
             </a-col>

              <a-col :span="9">
                <a-form-model-item label="籍贯" prop="a0111a">
                 <a-input :maxLength="20" v-model="BasicsInfo.a0111a" style="width: 200px"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="12">
              <a-form-model-item  label="健康状况" prop="a0127a">
                 <a-select allowClear  v-model="BasicsInfo.a0127a " style="width:  200px">
                  <a-select-option v-for="(item,i) in healthy" :key="i" :label="item.DMCOD" :value="item.DMCOD">{{item.DMCPT}}</a-select-option>
                 </a-select>
              </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
               <a-col :span="12">
              <a-form-model-item  label="特长" prop="a01102">
                <a-input :maxLength="25" v-model="BasicsInfo.a01102" style="width:  503px"></a-input>
              </a-form-model-item>
             </a-col>
            </a-row>


             <a-row>
               <a-col :span="12">
              <a-form-model-item  label="兴趣爱好" prop="a01103">
                <a-input :maxLength="25" v-model="BasicsInfo.a01103" style="width:  503px"></a-input>
              </a-form-model-item>
             </a-col>
            </a-row>
            
         

            <a-row>
             <a-col :span="12">
              <a-form-model-item label="移动电话" prop="zdyxa0145">
              <a-input :maxLength="20" onkeyup="this.value=this.value.replace(/[^\d]/g,'')" v-model="BasicsInfo.zdyxa0145" style="width: 200px"></a-input>
              </a-form-model-item>
             </a-col>

              <a-col :span="9">
                <a-form-model-item label="住址电话" prop="a0151a">
                 <a-input :maxLength="20" onkeyup="this.value=this.value.replace(/[^\d.-]/g,'')" v-model="BasicsInfo.a0151a" style="width: 200px"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>


            <a-row>
             <a-col :span="12">
              <a-form-model-item label="电子邮箱" prop="a0109">
              <a-input :maxLength="20" v-model="BasicsInfo.a0109" style="width: 200px"></a-input>
              </a-form-model-item>
             </a-col>

              <a-col :span="9">
                <a-form-model-item label="邮政编码" prop="zdyxa0108">
                 <a-input :maxLength="20" v-model="BasicsInfo.zdyxa0108" style="width: 200px"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>



             <a-row>
               <a-col :span="12">
              <a-form-model-item  label="通信地址" prop="a01107">
                <a-input :maxLength="60" v-model="BasicsInfo.a01107" style="width:  503px"></a-input>
              </a-form-model-item>
             </a-col>
            </a-row>


             <a-row>
               <a-col :span="12">
              <a-form-model-item  label="现住址" prop="a0110">
                <a-input :maxLength="60" v-model="BasicsInfo.a0110" style="width: 503px"></a-input>
              </a-form-model-item>
             </a-col>
            </a-row>
            

          </a-form-model>

        </div>

      </div>

      <!-- 第二部学习经历 -->
      <div v-show="step==2">
        <!-- 上方标题 -->
        <div>
          <div class="ryjbxxTitle">学习经历</div>
        </div>
        <!-- 下方内容 -->
        <div class="messages">
            <div class="remarks">
              备注 : 必填，从大学起填，最后一条为系统提取最高学历
            </div>
             <a-table :columns="studyColumns" :data-source="studyListDate"  :pagination="false">

                <template slot="cz" slot-scope="text,record">
                  <div class="df">
                   <a-button type="primary" shape="circle" icon="edit" @click="addStudy(record)" />
                   <a-button type="primary" shape="circle" icon="delete" @click="del1(record)" />
                  </div>
                 </template>

             </a-table>

             <!-- 新增 -->
             <div class="adds">
               <div @click="addStudy({})">+</div>
               <button @click="addStudy({})">新增</button>
             </div>
        </div>
        

      </div>

      <!-- 第三步工作或实习经历 -->
      <div v-show="step==3">
         <!-- 上方标题 -->
        <div>
          <div class="ryjbxxTitle">工作或实习经历</div>
        </div>
        <!-- 下方内容 -->
        <div class="messages">
             <a-table :columns="JobColums" :data-source="JobListDate"  :pagination="false">

                <span slot="todo" slot-scope="text,record">
                  <div class="df">
                   <a-button type="primary" shape="circle" icon="edit" @click="addJob(record)" />
                   <a-button type="primary" shape="circle" icon="delete" @click="del2(record)"  />
                  </div>
                 </span>

             </a-table>

             <!-- 新增 -->
             <div class="adds">
               <div @click="addJob({})">+</div>
               <button @click="addJob({})">新增</button>
             </div>
        </div>
      </div>

      <!-- 第四步家庭成员情况 -->
      <div v-show="step==4">
          <!-- 上方标题 -->
        <div>
          <div class="ryjbxxTitle">家庭成员情况</div>
        </div>
        <!-- 下方内容 -->
         <div class="remarks">
              备注 : 父母信息必填，有特殊情况可在“工作单位及职务”备注说明
        </div>
        <div class="messages">
             <a-table :columns="FamilyColums" :data-source="FamilyListDate"  :pagination="false">

                <span slot="todo" slot-scope="text,record">
                  <div class="df">
                   <a-button type="primary" shape="circle" icon="edit" @click="addFM(record)" />
                   <a-button type="primary" shape="circle" icon="delete" @click="del3(record)"/>
                  </div>
                 </span>

             </a-table>

             <!-- 新增 -->
             <div class="adds">
               <div @click="addFM({})">+</div>
               <button @click="addFM({})">新增</button>
             </div>
        </div>
      </div>

      <!-- 第五步应届生毕业信息 -->
      <div v-show="step==5">
         <!-- 上方标题 -->
        <div>
          <div class="ryjbxxTitle">应届生毕业生信息</div>
        </div>
        <!-- 下方内容 -->
        <div class="remarks">
             备注 : 仅为应届毕业生填写
        </div>
        <div class="messages">
        
        
          <a-form-model ref="StudentRef" :rules="StudentRules" :model="StudentInfo" :label-col="labelCol" :wrapper-col="wrapperCol">

            <a-row>
             <a-col :span="12" :offset="1">
              <a-form-model-item label="生源地" prop="a0186">
              <a-input :maxLength="20" v-model="StudentInfo.a0186" style="width: 180px"></a-input>
              </a-form-model-item>
             </a-col>

              <a-col :span="11">
                <a-form-model-item label="学校所在城市" prop="a01110">
                <a-input :maxLength="20" v-model="StudentInfo.a01110" style="width: 180px"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
             <a-col :span="12" :offset="1">
              <a-form-model-item label="英语等级或成绩 " prop="a01111">
              <a-input :maxLength="20" v-model="StudentInfo.a01111" style="width: 180px"></a-input>
              </a-form-model-item>
             </a-col>

              <a-col :span="11">
                <a-form-model-item label="是否委培生">
                 <a-checkbox-group v-model="StudentInfo.a01112">
                   <a-checkbox value="1" name="type">
                      
                   </a-checkbox>
                  </a-checkbox-group>
                </a-form-model-item>
              </a-col>
            </a-row>


            <a-row>
             <a-col :span="12" :offset="1">
               <a-form-model-item label="是否定向生">
                 <a-checkbox-group v-model="StudentInfo.a01113">
                   <a-checkbox value="1" name="dxs">
                      
                   </a-checkbox>
                  </a-checkbox-group>
                </a-form-model-item>
             </a-col>

              <a-col :span="11">
                <a-form-model-item label="是否计划外招生">
                 <a-checkbox-group v-model="StudentInfo.a01114">
                   <a-checkbox value="1" name="wzs">
                      
                   </a-checkbox>
                  </a-checkbox-group>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="15">
              <a-form-model-item  label="担任学生干部情况" prop="a0191">
                <a-input :maxLength="30" v-model="StudentInfo.a0191" style="width: 493px"></a-input>
              </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
               <a-col :span="15">
              <a-form-model-item  label="学校通讯地址" prop="a01116">
                <a-input :maxLength="30" v-model="StudentInfo.a01116" style="width: 493px"></a-input>
              </a-form-model-item>
             </a-col>
            </a-row>
            
            <a-row>
              <a-col :span="15">
              <a-form-model-item  label="学校邮政编码" prop="a01117">
                <a-input :maxLength="30" v-model="StudentInfo.a01117" style="width: 493px"></a-input>
              </a-form-model-item>
              </a-col>
            </a-row>
           

           

            <a-row>
             <a-col :span="12" :offset="1">
              <a-form-model-item label="系工作主管老师" prop="a01118">
              <a-input :maxLength="20" v-model="StudentInfo.a01118" style="width:180px"></a-input>
              </a-form-model-item>
             </a-col>

              <a-col :span="11">
                <a-form-model-item label="主管老师电话" prop="a01119">
                  <a-input :maxLength="20" v-model="StudentInfo.a01119" style="width:180px"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>

          <div class="txtarea">
            <a-row>
              <a-col :span="15">
                <a-form-model-item label="奖惩及学术科研成果" prop="a01115">
                 <a-input :maxLength="300" :auto-size="{ minRows: 5, maxRows: 6 }" type="textarea" :cols="20" :rows="5" v-model="StudentInfo.a01115"  style="width:493px"/>
                </a-form-model-item>
              </a-col>
            </a-row>
          </div>
            

          </a-form-model>
      
          

        </div>
      </div>

       <!-- 第六步社会招聘信息 -->
      <div v-show="step==6">
          <!-- 上方标题 -->
        <div>
          <div class="ryjbxxTitle">社会招聘信息</div>
        </div>
        <!-- 下方内容 -->
        <div class="remarks">
             备注 : 为社会招聘人员填写
        </div>
        <div class="messages">
        
        
          <a-form-model ref="SocialRef" :rules="SocialRules" :model="SocialInfo" :label-col="labelCol" :wrapper-col="wrapperCol">

            <a-row>
             <a-col :span="12" :offset="1">
              <a-form-model-item label="户籍所在地" prop="a0181a">
              <a-input :maxLength="20" v-model="SocialInfo.a0181a" style="width: 180px"></a-input>
              </a-form-model-item>
             </a-col>

              <a-col :span="11">
                <a-form-model-item label="档案所在地" prop="zdyxa0105">
                <a-input :maxLength="20" v-model="SocialInfo.zdyxa0105" style="width: 180px"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
             <a-col :span="12" :offset="1">
              <a-form-model-item label="首次工作时间 " prop="zdyxa123">
              <a-date-picker :inputReadOnly="true" placeholder="首次工作时间" show-tiem type="date" v-model="SocialInfo.zdyxa123" style="width: 180px"></a-date-picker>
              </a-form-model-item>
             </a-col>

              <a-col :span="11">
                 <a-form-model-item label="现工作状态 " prop="a01121">
              <a-input :maxLength="20" v-model="SocialInfo.a01121" style="width: 180px"></a-input>
              </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
             <a-col :span="12" :offset="1">
              <a-form-model-item label="现工作单位 " prop="a01122">
              <a-input :maxLength="20" v-model="SocialInfo.a01122" style="width: 180px"></a-input>
              </a-form-model-item>
             </a-col>

              <a-col :span="11">
              <a-form-model-item label="入职现单位时间 " prop="a01123">
              <a-date-picker :inputReadOnly="true" placeholder="入职时间" show-tiem type="date" v-model="SocialInfo.a01123" style="width: 180px"></a-date-picker>
              </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
             <a-col :span="12" :offset="1">
              <a-form-model-item label="现担任职务" prop="a01124">
              <a-input :maxLength="20" v-model="SocialInfo.a01124" style="width: 180px"></a-input>
              </a-form-model-item>
             </a-col>

              <a-col :span="11">
              <a-form-model-item label="任职时间" prop="a0113">
              <a-date-picker :inputReadOnly="true" placeholder="任职时间" show-tiem type="date" v-model="SocialInfo.a0113" style="width: 180px"></a-date-picker>
              </a-form-model-item>
              </a-col>
            </a-row>
            
          <div class="txtarea">
            <a-row>
              <a-col :span="15">
                <a-form-model-item label="工作技能" prop="a01125">
                 <a-input :maxLength="300" :auto-size="{ minRows: 5, maxRows: 6 }" type="textarea" :cols="20" :rows="5" v-model="SocialInfo.a01125" placeholder="若没有就填无（500字以内）"/>
                </a-form-model-item>
              </a-col>
            </a-row>
          </div>

          <div class="txtarea">
            <a-row>
              <a-col :span="15">
                <a-form-model-item label="奖惩情况" prop="a01126">
                 <a-input :maxLength="300" :auto-size="{ minRows: 5, maxRows: 6 }" type="textarea" :cols="20" :rows="5" v-model="SocialInfo.a01126" placeholder="若没有就填无（500字以内）" style="width:493px"/>
                </a-form-model-item>
              </a-col>
            </a-row>
          </div>
            

          </a-form-model>
      
        
        </div>
      </div>
    </div>
      



      <div class="dialogFooter">
       <!-- 按钮上一步 -->
        <button class="btnStyle1" @click="LastStep" v-show="step>1">上一步</button>
        <!-- 下一步 -->
        <button class="btnStyle1" @click="NextStep" v-show="step<6">下一步</button>
        <!-- 确认提交 -->
        <button class="btnStyle1" @click="sureSub"  v-show="step==6">确认提交</button>
        <!-- 取消 -->
        <button class="btnStyle1" @click="cancel">取消</button>
      </div>
     

    </a-modal>


    <xxjl :studyVisible.sync="studyVisible" :studyInfo="studyInfo" @updt="updt1"></xxjl>

    <ssjl :JobVisible.sync="JobVisible" :jobInfo="jobInfo" @updt="updt2"></ssjl>

    <jtcy :FMVisible.sync="FMVisible" :FMInfo="FMInfo" @updt="updt3"></jtcy>
    <a-modal
      title="确认提示"
      :visible="ConfirmVisible"
      @ok="ConfirmHandleOk"
      @cancel="ConfirmHandleCancel"
    >
      <p>本人将完整填写简历信息，并保证所填内容真实有效，如有不实，本人愿承担相应责任</p>
    </a-modal>
  </div>
</template>



<script>


import xxjl from '../compos/xxjl.vue'
import ssjl from '../compos/ssjl.vue'
import jtcy from '../compos/jtcy.vue'

import moment from 'moment'
import { setTimeout } from 'timers';
export default {
  components:{
      xxjl,ssjl,jtcy
    },
  props:{
    visible:{
       type:Boolean,
      require:true
    },
    gwbbData:{
      type:Object,
      require:true
    },
    ksplace:{
      type:Array,
      require:true
    }
  },
  data(){
     //验证身份证的正则表达式
    let validateSfz = (rule, value, callback) => {
      var reg =/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
      if (!reg.test(value)) {
        callback(new Error('身份证号格式错误'));
      }else{
        callback();
      }
    }
  //移动电话
    let validateYddh = (rule, value, callback) => {
      var reg = /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9]|17[0|1|2|3|5|6|7|8|9])\d{8}$/;
      if (!reg.test(value)) {
        callback(new Error('移动电话格式错误'));
      }else{
        callback();
      }
    }
    //电子邮箱
    let validateDzyx = (rule, value, callback) => {
      var reg = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
      if (!reg.test(value)) {
        callback(new Error('电子邮箱格式错误'));
      }else{
        callback();
      }
    }

    //邮政编码
    let validateYzbm = (rule, value, callback) => {
      var reg =  /^[0-9]\d{5}(?!\d)$/;
      if (!reg.test(value)) {
        callback(new Error('邮政编码格式错误'));
      }else{
        callback();
      }
    }

    //身高小于250
    let validatesg= (rule, value, callback) => {
      if (value>250) {
        callback(new Error('输入的身高过高'));
      }else{
        callback();
      }
    }

    //体重小于200Kg
    let validatetz= (rule, value, callback) => {
      if (value>200) {
        callback(new Error('您输入的体重过高'));
      }else{
        callback();
      }
    }

    //不能为负数
    let validatefs = (rule, value, callback) => {
      var reg =   /^\+?((0|([1-9]+\d*))|((0\.\d+)|([1-9]+\d*\.\d+)))$/;
      if (!reg.test(value)) {
        callback(new Error('格式不正确'));
      }else{
        callback();
      }
    }

    //身份证和出生日期是否匹配
    let validatesfrq= (rule, value, callback) => {
      var date = value.slice(6,14)
      var newdate = date.slice(0,4)+'-'+date.slice(4,6)+'-'+date.slice(6,8)
      // this.a0107
      var nowD=moment(this.BasicsInfo.a0107).format('YYYY-MM-DD');
      if (newdate!=nowD) {
        callback(new Error('出生日期不一致'));
      }else{
        callback();
      }
    }

    //身份证和性别是否匹配
    let validatesfxb= (rule, value, callback) => {
      var date = value.slice(-2,-1)
      var sex = ''
      var sex2 = ''

      if (date%2 == 1){
        sex = '男'
      } else if(date%2 == 0){
        sex = '女'
      }

      if (this.BasicsInfo.a0104 == 1){
        sex2 = '男'
      } else if(this.BasicsInfo.a0104 == 2){
        sex2 = '女'
      } else if(this.BasicsInfo.a0104 == '男'){
        sex2 = '男'
      } else if(this.BasicsInfo.a0104 == '女'){
        sex2 = '女'
      }

      if (sex!=sex2) {
        callback(new Error('与您填入的性别不同'));
      }else{
        callback();
      }
    }
    return{
      ConfirmVisible: false,
      showVisible:false,

      labelCol: { span: 9 },
      wrapperCol: { span: 10 },

      //哪一步
      step:1,

      //储存人员主键
      a00:'',

      //学习经历的对话框
      studyVisible:false,
      ///工作经历对话框
      JobVisible:false,
      //家庭对话框
      FMVisible:false,
      //对话框第几步
      step:1,
      //学习经历表格数据
      studyListDate:[],
      //学习经历表格头
      studyColumns:[
        {
          title: '入学时间',
          dataIndex: 'a0801',
          ellipsis: true,
          key: 'a0801',
        },
        {
          title: '毕业时间',
          dataIndex: 'a0802',
          ellipsis: true,
          key: 'a0802',
        },
        {
          title: '学历',
          dataIndex: 'a0803',
          ellipsis: true,
          key: 'a0803',
        },
        {
          title: '学位',
          dataIndex: 'a0804',
          ellipsis: true,
          key: 'a0804',
        },
        {
          title: '院校',
          dataIndex: 'a0805',
          ellipsis: true,
          key: 'a0805',
        },
        {
          title: '学院',
          dataIndex: 'a0806',
          ellipsis: true,
          key: 'a0806',
        },
        {
          title: '所学专业',
          dataIndex: 'a0807',
          ellipsis: true,
          key: 'a0807',
        },
        {
          title: '教育类型',
          dataIndex: 'a0813',
          ellipsis: true,
          key: 'a0813',
        },
        {
          title: '学制',
          dataIndex: 'a0814',
          key: 'a0814',
        },
        {
          title: '操作',
          dataIndex: 'cz',
          key: 'cz',
          scopedSlots: { customRender: 'cz' },
        }
      ],
      //工作或实习经历表格头
      JobColums:[  
        {
          title: '起始时间',
          dataIndex: 'a4801',
          key: 'a4801',
        },
        {
          title: '截止日期',
          dataIndex: 'a4802',
          key: 'a4802',
        },
        {
          title: '组织或公司名称',
          dataIndex: 'a4803',
          ellipsis: true,
          key: 'a4803',
        },
        {
          title: '工作单位及职务',
          dataIndex: 'a4805',
          ellipsis: true,
          key: 'a4805',
        },
        {
          title: '操作',
          dataIndex: 'todo',
          key: 'todo',
          scopedSlots: { customRender: 'todo' },
        }
      ],
      //工作或实习经历表格数据
      JobListDate:[],
      //家庭情况表头
      FamilyColums:[
         {
          title: '姓名',
          dataIndex: 'a1501',
          key: 'a1501',
        },
        {
          title: '与本人关系',
          dataIndex: 'a1503',
          key: 'a1503',
        },
        {
          title: '民族',
          dataIndex: 'a1506',
          key: 'a1506',
        },
        {
          title: '政治面貌',
          dataIndex: 'a1504',
          ellipsis: true,
          key: 'a1504',
        },
        {
          title: '联系电话',
          dataIndex: 'a1508',
          ellipsis: true,
          key: 'a1508',
        },
        {
          title: '工作单位及职务',
          dataIndex: 'a1505',
          ellipsis: true,
          key: 'a1505',
        },
        {
          title: '出生日期',
          dataIndex: 'a1507',
          key: 'a1507',
        },
        {
          title: '操作',
          dataIndex: 'todo',
          key: 'todo',
          scopedSlots: { customRender: 'todo' },
        }
      ],
      // 家庭情况表格数据
      FamilyListDate:[],

    
      dialogStyle: {
        right:"100px"
      },
     
     
       //下拉框数据
      //  学历
      educationList:[ ],
      //考试地点
      places:[],
      // 性别
      sexList:[],
      //民族
      nations: [], 
      //政治面貌
      Political:[],
      // 婚姻
      marriage:[],
      //健康状态
      healthy:[],


      //应届生基本信息
      BasicsInfo:{},
      //应届毕业生信息表单数据
      StudentInfo:{},
      //社会招聘信息表单数据
      SocialInfo:{},


   


      //传给子组件的信息
      studyInfo:{},
      jobInfo:{},
      FMInfo:{},



      // 基础信息校验规则
      baseRules:{
        a0185:[
          { required: true, message: '请输入考试地点', trigger: 'blur' },
        ],
        a0101: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 1, max: 8, message: '请输入正确的姓名', trigger: 'blur' },
        ],
        a0104: [
          { required: true, message: '请输入性别', trigger: 'blur' },
        ],
        a0117: [
          { required: true, message: '请输入民族', trigger: 'blur' },
        ],
        a0141: [
          { required: true, message: '请输入政治面貌', trigger: 'blur' },
        ],
        a0107: [
          { required: true, message: '请输入出生日期', trigger: 'change' },
        ],
        a0108: [
          { required: true, message: '请输入身高', trigger: 'blur' },
          { validator: validatesg, trigger: 'blur' },
          { validator: validatefs, trigger: 'blur' },
        ],
        a01101: [
          { required: true, message: '请输入体重', trigger: 'blur' },
          { validator: validatetz, trigger: 'blur' },
          { validator: validatefs, trigger: 'blur' },
        ],
        a0131: [
          { required: true, message: '请输入婚姻状态', trigger: 'blur' },
        ],
        a0184: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: validateSfz, trigger: 'blur' },
          // { validator: validatefs, trigger: 'blur' },
          { validator: validatesfrq, trigger: 'blur' },
          { validator: validatesfxb, trigger: 'blur' }
        ],
        a0111a: [
          { required: true, message: '请输入籍贯', trigger: 'blur' },
        ],
        a0127a: [
        ],
        a01102: [
        ],
        a01103: [
        ],
        zdyxa0145: [
          { validator: validateYddh, trigger: 'blur' }
        ],
        a0151a: [
        ],
        a0109: [
          { required: true, message: '请输入电子邮箱', trigger: 'blur' },
          { validator: validateDzyx, trigger: 'blur' }
        ],
        zdyxa0108: [
          { required: true, message: '请输入邮政编码', trigger: 'blur' },
          { validator: validateYzbm, trigger: 'blur' }
        ],
        a01107: [
          { required: true, message: '请输入通讯地址', trigger: 'blur' },
        ],
        a0110: [
        ],
        
      },

      //应届毕业生信息校验规则
      StudentRules:{
        a0186: [
          { required: true, message: '请输入生源地', trigger: 'blur' },
        ],
       
      },

      //社会招聘信息校验规则
      SocialRules:{
        a0181a: [
          { required: true, message: '请输入户籍所在地', trigger: 'blur' },
        ],
        zdyxa123: [
          { required: true, message: '请输入首次参加工作时间', trigger: 'change' },
        ],
        a01123: [
          { required: true, message: '请输入入职时间', trigger: 'change' },
        ],
        a0113: [
          { required: true, message: '请输入任职时间', trigger: 'change' },
        ],
      },


      //家庭成员状态信息
      sta:null,

      //首页获取的a0187的的数据
      a0187S:''
    }
  },

   mounted(){
    this.showVisible=this.visible
    this.places=this.ksplace
  },

  watch:{
    visible(){
      console.log(997894);
      this.showVisible=this.visible
       this.getxl()
       this.gethy()
        this.getjk()
        this.getmz()
        this.getzzmm()
        this.getBasicInfo()
        this.getLearningExperienceByA00()
        this.getWorkExperienceByA00()
        this.getFamilyNumbersByA00()
        this.getYjbysInfo()
        this.getShzpInfo()
    },
    ksplace(){
      this.places=this.ksplace
    }
  },


  methods:{
   
    // 关闭弹窗
    cancel(){
      this.$refs.StudentRef.resetFields()
      this.$refs.SocialRef.resetFields()
      this.$refs.baseRef.resetFields()
      this.BasicsInfo.a0185=''
      this.step=1
      this.showVisible=false
      this.$emit('update:visible',false)
    },

    //点击了上一步
    LastStep(){
      console.log(this.step);
       if(this.step==1){
        this.updateBasicInfo(2)
      }else if(this.step==5){
        this.updateYjbysInfo(2)
      }else if(this.step==6){
        if(this.SocialInfo.zdyxa123!=null&&this.SocialInfo.a01123!=null&&this.SocialInfo.a0113!=null){
          this.updateShzpInfo(2)
        }else{
          this.step--
          // this.$refs['SocialRef'].resetFields()
        }
      }else if(this.step==2||this.step==3||this.step==4){
        this.step--
      }

    },
    sureSub(){
      this.ConfirmVisible = true
    },
    //点击了确认提交
    ConfirmHandleOk(){
       // 格式化日期的函数
      function getTargetTime(t){
        var d = t.split(" ")[0],
        h = t.split(" ")[1],
        date = new Date()

        date.setYear(d.split("-")[0])
        date.setMonth(d.split("-")[1] - 1)
        date.setDate(d.split("-")[2])

    
        return date.getTime()    
      }
      this.$refs.SocialRef.validate(valid => {
        console.log(valid,this.sta);
        if(valid||this.sta){
          //     if(typeof(this.SocialInfo.zdyxa123)=='string'){
      //   if(getTargetTime(this.SocialInfo.zdyxa123)>new Date().getTime()) return this.$message.warning('首次参加工作时间不能晚于当前时间');
      // }else if(typeof(this.SocialInfo.zdyxa123)=='object'){
      //  if((this.SocialInfo.zdyxa123).unix()*1000>new Date().getTime()) return this.$message.warning('首次参加工作时间不能晚于当前时间');
      // }

      // if(typeof(this.SocialInfo.a01123)=='string'){
      //   console.log(1);
      //   if(getTargetTime(this.SocialInfo.a01123)>new Date().getTime()) return this.$message.warning('入职时间不能晚于当前时间');
      // }else if(typeof(this.SocialInfo.zdyxa123)=='object'){
      //  if((this.SocialInfo.a01123).unix()*1000>new Date().getTime()) return this.$message.warning('入职时间不能晚于当前时间');
      // }

      // console.log(123);
      // if(typeof(this.SocialInfo.a0113)=='string'&&(typeof(this.SocialInfo.a01123)=='string')){
      //    console.log(1);
      //    if(getTargetTime(this.SocialInfo.a0113)<getTargetTime(this.SocialInfo.a01123)) return this.$message.warning('入职时间不能晚于任职时间');
      //  }else if(typeof(this.SocialInfo.a0113)=='string'){
      //    console.log(2);
      //    if(getTargetTime(this.SocialInfo.a0113)<(this.SocialInfo.a01123).unix()*1000) return this.$message.warning('入职时间不能晚于任职时间');
      //  }else if(typeof(this.SocialInfo.a01123)=='string'){
      //    console.log(3);
      //    if((this.SocialInfo.a0113).unix()*1000<getTargetTime(this.SocialInfo.a01123)) return this.$message.warning('入职时间不能晚于任职时间');
      //  }else if(typeof(this.SocialInfo.a0113)=='object'&&(typeof(this.SocialInfo.a01123)=='object')){
      //    console.log(4);
      //    if((this.SocialInfo.a0113).unix()<(this.SocialInfo.a01123).unix()) return this.$message.warning('入职时间不能晚于任职时间');
          //  }
          console.log(this.SocialInfo.zdyxa123);
          console.log(this.SocialInfo.a0113);
          console.log(this.SocialInfo.a01123);
          if(this.SocialInfo.zdyxa123!=null&&this.SocialInfo.a01123!=null&&this.SocialInfo.a0113!=null){
            this.updateShzpInfo()
            this.ConfirmVisible = false
          }
          console.log(this.gwbbData.JOBID,this.BasicsInfo.a0187,this.gwbbData.BATCHID);
          this.post({
            url:'gwbbApply',
            data:{
              A00:sessionStorage.getItem('aabb'),
              BATCHID:this.gwbbData.BATCHID,
              EXAMADD:this.a0187S,
              JOBID:this.gwbbData.JOBID,
              PLACEID:this.BasicsInfo.a0185,
              PUSERID:sessionStorage.getItem('a0b'),
              baseTable:'1'
            }
          },(res)=>{
            if(res.code!==200) return this.$message.error(res.message)
            this.ConfirmVisible = false
            console.log(res);
            this.cancel()
          })
        }else{
          this.ConfirmVisible = false
          return this.$message.warning('应届毕业生信息和社会招聘信息至少需要完成一类！')
        }
      })
    },
    ConfirmHandleCancel(){
      this.ConfirmVisible = false
      this.$message.warning('您已取消申请职位!')
    },
    //点击了下一步
    NextStep(){
      console.log(this.step);
      
      if(this.step==1){
        this.updateBasicInfo(1)
      }else if(this.step==5){
        this.updateYjbysInfo(1)
      }else if(this.step==6){
        this.updateShzpInfo(1)
      }else if(this.step==2||this.step==3||this.step==4){
        this.step++
      }

      
    },

    //打开添加学习经历的对话框
    addStudy(r){
       var b=JSON.stringify(r);
      if(b === '{}') {
        console.log(1);
      }else{
        r.biaoji=true
      }
      
      this.studyInfo=r
      console.log(this.studyInfo);
      this.studyVisible=true
    },

    //打开添加工作经历的对话框
    addJob(r){
       var b=JSON.stringify(r);
      if(b === '{}') {
        console.log(1);
      }else{
        r.biaoji=true
      }
      console.log(r);
      
      this.jobInfo=r
      this.JobVisible=true
    },

    //打开添加家庭成员的对话框
    addFM(r){
       var b=JSON.stringify(r);
      if(b === '{}') {
        console.log(1);
      }else{
        r.biaoji=true
      }
      
      this.FMInfo=r
      console.log(this.FMInfo);
      this.FMVisible=true
    },

    // 删除学习经历
    del1(r){
       var that=this
      var ids=r
      this.$confirm({
        title: '确认删除吗?',
        okText: '确认',
        cancelText: '取消',
        onOk() {
        that.post({
          url:'deleteLearningExperience',
          data:{
            recordId:ids.recordid
          }
        },(res)=>{
          if(res.code=200){
            that.$message.success('删除学习经历成功')
            that.getLearningExperienceByA00()
          }else{
            that.$message.error(res.message)
          }
        })
        },
        onCancel() {},
      });
    },

    // 删除工作经历
    del2(r){
      var that=this
      var ids=r
      this.$confirm({
        title: '确认删除吗?',
        okText: '确认',
        cancelText: '取消',
        onOk() {
        that.post({
        url:'deleteWorkExperience',
        data:{
          recordId:ids.recordid,
          'BDSOFT-TOKEN':sessionStorage.getItem('BDSOFT-TOKEN')
        }
    
      },(res)=>{
        if(res.code=200){
          that.$message.success('删除工作经历成功')
          that.getWorkExperienceByA00()
        }else{
          this.$message.error(res.message)
        }
      })
      },
        onCancel() {},
      });
    },

    // 删除家庭成员
    del3(r){
      var that=this
      var ids=r
      this.$confirm({
        title: '确认删除吗?',
        okText: '确认',
        cancelText: '取消',
        onOk() {
        that.post({
        url:'deleteFamilyNumber',
        data:{
          recordId:ids.recordid
        }
      },(res)=>{
        if(res.code=200){
          that.$message.success('删除家庭成员成功')
          that.getFamilyNumbersByA00()
        }else{
          that.$message.error(res.message)
        }
      })
        },
        onCancel() {},
      });
    },


    // 获取简历基本信息
    getBasicInfo(){
      this.post({
        url:'getBasicInfo',
        data:{
          a00:sessionStorage.getItem('aabb')
        }
      },(res)=>{
        var ishave = this.places.some(i=>{
          return i.EXAMADRESS == res.data.a0185
        })
        if(!ishave) {
          res.data.a0185=''
        }
        
        console.log(789);
        console.log(res);
        if(res.data.a0187!=null){
          res.data.a0187=[res.data.a0187]
        }

        if(!isNaN((res.data.a0185)*1)){
          this.places.map(i=>{
           if(i.PLACEID==(res.data.a0185)*1){
            res.data.a0185= i.PLACEID
          }
          })
        }

        if(!isNaN((res.data.a0104)*1)){
          this.sexList.map(i=>{
           if(i.DMCOD==(res.data.a0104)*1){
            res.data.a0104= i.DMCPT
          }
          })
        }
        
        if(!isNaN((res.data.a0117)*1)){
        this.nations.map(i=>{
           if(i.DMCOD==res.data.a0117){
            res.data.a0117= i.DMCPT
          }
        })
        }

        if(!isNaN((res.data.a0141)*1)){
        this.Political.map(i=>{
           if(i.DMCOD==res.data.a0141){
            res.data.a0141= i.DMCPT
          }
        })
        }

        if(!isNaN((res.data.a0131)*1)){
        this.marriage.map(i=>{
           if(i.DMCOD==res.data.a0131){
            res.data.a0131= i.DMCPT
          }
        })
        }

        if(!isNaN((res.data.a0127a)*1)){
        this.healthy.map(i=>{
           if(i.DMCOD==res.data.a0127a){
            res.data.a0127a= i.DMCPT
          }
        })
        }
        this.BasicsInfo=res.data
      })
    },

    //获取简历学习经历
    getLearningExperienceByA00(){
       this.post({
        url:'getLearningExperienceByA00',
        data:{
          A00:sessionStorage.getItem('aabb')
        }
      },(res)=>{
        this.studyListDate=res.data
      })
    },

    //获取工作或实习经历
    getWorkExperienceByA00(){
      this.post({
        url:'getWorkExperienceByA00',
        data:{
          A00:sessionStorage.getItem('aabb')
        }
      },(res)=>{
        this.JobListDate=res.data
      })
    },

    //获取家庭成员经历
    getFamilyNumbersByA00(){
       this.post({
        url:'getFamilyNumbersByA00',
        data:{
          A00:sessionStorage.getItem('aabb')
        }
      },(res)=>{
        this.FamilyListDate=res.data
      })
    },

    //获取应届毕业生信息
    getYjbysInfo(){
      this.post({
        url:'getYjbysInfo',
        data:{
          a00:sessionStorage.getItem('aabb')
        }
      },(res)=>{
        
        if(res.data.a01112!=null){
          res.data.a01112=[res.data.a01112]
        }
         if(res.data.a01113!=null){
          res.data.a01113=[res.data.a01113]
        }
         if(res.data.a01114!=null){
          res.data.a01114=[res.data.a01114]
        }
        console.log(res);
        this.StudentInfo=res.data
      })
    },
    //获取社会招聘信息
    getShzpInfo(){
      this.post({
        url:'getShzpInfo',
        data:{
          a00:sessionStorage.getItem('aabb')
        }
      },(res)=>{
        console.log(res);
        this.SocialInfo=res.data
      })
    },


    updt1(){
      this.getLearningExperienceByA00()
    },

    updt2(){
      this.getWorkExperienceByA00()
    },

    updt3(){
      this.getFamilyNumbersByA00()
    },


    //修改简历基本信息
    updateBasicInfo(r){
       // 格式化日期的函数
       function getTargetTime(t){
        var d = t.split(" ")[0],
        h = t.split(" ")[1],
        date = new Date()

        date.setYear(d.split("-")[0])
        date.setMonth(d.split("-")[1] - 1)
        date.setDate(d.split("-")[2])

    
        return date.getTime()    
      }
      this.$refs.baseRef.validate(valid => {
        if(!valid) return this.$message.warning('请完成表单内容')
      if(typeof(this.BasicsInfo.a0107)=='string'){
        if(getTargetTime(this.BasicsInfo.a0107)>new Date().getTime()) return this.$message.warning('出生日期不能晚于当前时间');
      }else{
       if((this.BasicsInfo.a0107).unix()*1000>new Date().getTime()) return this.$message.warning('出生日期不能晚于当前时间');
      }

      
  
      //此处还需要做把ant的moment对象转换成字符串格式
        this.BasicsInfo.a0107=moment(this.BasicsInfo.a0107).format('YYYY-MM-DD');
      //  this.BasicsInfo.a0113=moment(this.BasicsInfo.a0113).format('YYYY-MM-DD');
      this.BasicsInfo.a01123=moment(this.BasicsInfo.a01123).format('YYYY-MM-DD');
      this.BasicsInfo.updatetime=moment(this.BasicsInfo.updatetime).format('YYYY-MM-DD');
      // this.BasicsInfo.zdyxa123=moment(this.BasicsInfo.zdyxa123).format('YYYY-MM-DD');
      //此处把表单的下拉框数据转换为真实值
      if(!typeof(this.BasicsInfo.a0185*0)!=='number'){
       this.places.map(i=>{
        if(i.PLACEID==this.BasicsInfo.a0185){
            this.BasicsInfo.a0185= i.PLACEID
        }
      })
      }else{
        // this.BasicsInfo.a0117*0+1
      }

       if(!typeof(this.BasicsInfo.a0104*0)!=='number'){
        this.sexList.map(i=>{
        if(i.DMCPT==this.BasicsInfo.a0104){
            this.BasicsInfo.a0104= i.DMCOD
        }
      })
      }else{
        // this.BasicsInfo.a0104*0+1
      }
      
      if(!typeof(this.BasicsInfo.a0117*0)!=='number'){
       this.nations.map(i=>{
        if(i.DMCPT==this.BasicsInfo.a0117){
            this.BasicsInfo.a0117= i.DMCOD
        }
      })
      }else{
        // this.BasicsInfo.a0117*0+1
      }

      if(!typeof(this.BasicsInfo.a0141*0)!=='number'){
      this.Political.map(i=>{
        if(i.DMCPT==this.BasicsInfo.a0141){
            this.BasicsInfo.a0141= i.DMCOD
        }
      })
      }else{
        // this.BasicsInfo.a0141*0+1
      }

      if(!typeof(this.BasicsInfo.a0131*0)!=='number'){
      this.marriage.map(i=>{
        if(i.DMCPT==this.BasicsInfo.a0131){
            this.BasicsInfo.a0131= i.DMCOD
        }
      })
      }else{
        // this.BasicsInfo.a0131*0+1
      }

       if(!typeof(this.BasicsInfo.a0127a*0)!=='number'){
      this.healthy.map(i=>{
        if(i.DMCPT==this.BasicsInfo.a0127a){
            this.BasicsInfo.a0127a= i.DMCOD
        }
      })
      }else{
        // this.BasicsInfo.a0127a*0+1
      }
      

      //表单里多选框内容为数组，这里将其转换为字符串再上传
      
      var ddd=JSON.stringify(this.BasicsInfo)
      var eee=JSON.parse(ddd)
      var dist=eee
      
       dist.a0187=null
      if(this.BasicsInfo.a0187){
        dist.a0187=this.BasicsInfo.a0187[0]
        this.a0187S=dist.a0187
      }else{
        dist.a0187=null
        this.a0187S=null
      }

      
      console.log(dist);
      if(r==1){
        this.step++
      }else if(r==2){
        this.step--
      }
      this.post({
        url:'updateBasicInfo',
        data:dist
      },(res)=>{
        console.log(res);
        if(res.code==200){
          this.$message.success('修改简历信息成功')
        }else{
          this.$message.error(res.message)
        }
      })
      })
    },
    //修改社会招聘信息
    updateShzpInfo(r){
      // 格式化日期的函数
       function getTargetTime(t){
        var d = t.split(" ")[0],
        h = t.split(" ")[1],
        date = new Date()

        date.setYear(d.split("-")[0])
        date.setMonth(d.split("-")[1] - 1)
        date.setDate(d.split("-")[2])

    
        return date.getTime()    
      }
       this.$refs.SocialRef.validate(valid => {
        if(r==1&&!valid) return this.$message.warning('请完成表单内容')
      this.SocialInfo.a00=sessionStorage.getItem('aabb')


      //  if(typeof(this.SocialInfo.zdyxa123)=='string'){
      //   if(getTargetTime(this.SocialInfo.zdyxa123)>new Date().getTime()) return this.$message.warning('首次参加工作时间不能晚于当前时间');
      // }else if(typeof(this.SocialInfo.zdyxa123)=='object'){
      //  if((this.SocialInfo.zdyxa123).unix()*1000>new Date().getTime()) return this.$message.warning('首次参加工作时间不能晚于当前时间');
      // }

      // if(typeof(this.SocialInfo.a01123)=='string'){
      //   console.log(1);
      //   if(getTargetTime(this.SocialInfo.a01123)>new Date().getTime()) return this.$message.warning('入职时间不能晚于当前时间');
      // }else if(typeof(this.SocialInfo.zdyxa123)=='object'){
      //  if((this.SocialInfo.a01123).unix()*1000>new Date().getTime()) return this.$message.warning('入职时间不能晚于当前时间');
      // }

      console.log(123);
      // if(typeof(this.SocialInfo.a0113)=='string'&&(typeof(this.SocialInfo.a01123)=='string')){
      //    console.log(1);
      //    if(getTargetTime(this.SocialInfo.a0113)<getTargetTime(this.SocialInfo.a01123)) return this.$message.warning('入职时间不能晚于任职时间');
      //  }else if(typeof(this.SocialInfo.a0113)=='string'){
      //    console.log(2);
      //    if(getTargetTime(this.SocialInfo.a0113)<(this.SocialInfo.a01123).unix()*1000) return this.$message.warning('入职时间不能晚于任职时间');
      //  }else if(typeof(this.SocialInfo.a01123)=='string'){
      //    console.log(3);
      //    if((this.SocialInfo.a0113).unix()*1000<getTargetTime(this.SocialInfo.a01123)) return this.$message.warning('入职时间不能晚于任职时间');
      //  }else if(typeof(this.SocialInfo.a0113)=='object'&&(typeof(this.SocialInfo.a01123)=='object')){
      //    console.log(4);
      //    if((this.SocialInfo.a0113).unix()<(this.SocialInfo.a01123).unix()) return this.$message.warning('入职时间不能晚于任职时间');
      //  }
        

      //此处还需要做把ant的moment对象转换成字符串格式 
      this.SocialInfo.zdyxa123=moment(this.SocialInfo.zdyxa123).format('YYYY-MM-DD');
      this.SocialInfo.a0113=moment(this.SocialInfo.a0113).format('YYYY-MM-DD');
      this.SocialInfo.a01123=moment(this.SocialInfo.a01123).format('YYYY-MM-DD');
      
      // this.$refs['StudentRef'].resetFields()

      // console.log(this.SocialInfo);
      if(r==1){
        this.step++
      }else if(r==2){
        this.step--
      }
       this.post({
        url:'updateShzpInfo',
        data:this.SocialInfo
      },(res)=>{
        // console.log(res);
         if(res.code==200){
          this.$message.success('更新社会招聘信息成功')
        }else{
          this.$message.error(res.message)
        }
      })
       })
    },
    //修改应届毕业生信息
    updateYjbysInfo(r){
      // this.$confirm({
      //   title: 'Do you want to delete these items?',
      //   content: 'When clicked the OK button, this dialog will be closed after 1 second',
      //   onOk() {
      //     // return new Promise((resolve, reject) => {
      //     //   setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
      //     // }).catch(() => console.log('Oops errors!'));
      //     that.$message.success('aa')
      //   },
      //   onCancel() {},
      //  });


       this.$refs.StudentRef.validate(valid => {
        if(!valid){
          var that=this
          this.$confirm({
          title:'提示',
          content: '请先完成表单内容',
          cancelText: '跳过',
          okText: '重填',
          onOk() {
            
          },
          onCancel() {
            // that.$refs['StudentRef'].resetFields()
            if(r==1){
              that.step++
              that.sta=false
            }else if(r==2){
              that.step--
            }
          },
        });
      } else{
      this.StudentInfo.a00=sessionStorage.getItem('aabb')
      console.log(this.StudentInfo);
      //表单里多选框内容为数组，这里将其转换为字符串再上传
      
      var ddd=JSON.stringify(this.StudentInfo)
      var eee=JSON.parse(ddd)
      var dist=eee
      
       dist.a01112=null
       dist.a01113=null
       dist.a01114=null
      if(this.StudentInfo.a01112){
        dist.a01112=this.StudentInfo.a01112[0]
      }else{
        dist.a01112=null
      }

      if(this.StudentInfo.a01113){
        dist.a01113=this.StudentInfo.a01113[0]
      }else{
        dist.a01113=null
      }

      if(this.StudentInfo.a01114){
        dist.a01114=this.StudentInfo.a01114[0]
      }else{
        dist.a01114=null
      }
      
     
      // console.log(dist);
      if((!/^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9]|17[0|1|2|3|5|6|7|8|9])\d{8}$/.test(this.StudentInfo.a01119)) && !this.StudentInfo.a01119==''){
        return this.$message.error('主管老师电话格式不正确')
      }

      if((!/^[0-9]\d{5}(?!\d)$/.test(this.StudentInfo.a01117)) && !this.StudentInfo.a01117==''){
        return this.$message.error('邮政编码格式不对')
      }
      
      if(r==1){
        this.step++
        this.sta=true
      }else if(r==2){
        this.step--
      }
      var that=this
       this.post({
        url:'updateYjbysInfo',
        data:dist
      },(res)=>{
        // console.log(res);
        if(res.code=200){
          this.$message.success('更新应届生毕业信息成功')
        }else{
          this.$message.error(res.message)
        }
      })
      }
      })
    },


    //查询代码表
    //政治面貌
    getzzmm(){
      this.get({
        url:'getCodeTableAndKeyWordAllItem',
        data:{
          codeTableName:'GB4762'
        }
      },(res)=>{
        if(res.code=200){
          this.Political=res.data
        }
      })
    },

    //学历
    getxl(){
      this.get({
        url:'getCodeTableAndKeyWordAllItem',
        data:{
          codeTableName:'BJ012'
        }
      },(res)=>{
        if(res.code=200){
          this.educationList=res.data
        }
      })
    },

    //性别
    getxl(){
      this.get({
        url:'getCodeTableAndKeyWordAllItem',
        data:{
          codeTableName:'GB22611'
        }
      },(res)=>{
        if(res.code==200){
          this.sexList=res.data
        }
      })
    },

    //民族
    getmz(){
      this.get({
        url:'getCodeTableAndKeyWordAllItem',
        data:{
          codeTableName:'GB3304'
        }
      },(res)=>{
        if(res.code==200){
          this.nations=res.data
        }
      })
    },

    //婚姻
    gethy(){
      this.get({
        url:'getCodeTableAndKeyWordAllItem',
        data:{
          codeTableName:'GB22612'
        }
      },(res)=>{
        if(res.code==200){
          this.marriage=res.data
        }
      })
    },

    //健康状态
    getjk(){
      this.get({
        url:'getCodeTableAndKeyWordAllItem',
        data:{
          codeTableName:'GB22613'
        }
      },(res)=>{
        if(res.code==200){
          this.healthy=res.data
        }
      })
    },

    getBit (value, bit) {
      let str = Number(value);
      str = str.toFixed(bit)
      console.log(str)
      return str;
  },

  //禁止输入负数
  proving2(e) {
            // console.log(e.target.value)
            // console.log(this.getBit(e.target.value,1))
            var keynum = window.event ? e.keyCode : e.which;   //获取键盘码
            var keychar = String.fromCharCode(keynum);  //获取键盘码对应的字符
            if (keynum ==189||keynum == 109) { //禁止输入负数
              this.$message.warning('禁止输入负数')
              e.target.value = 0
            }
  },

    //考试地点
    // getPlaceid(){
    //   console.log(this.gwbbData.BATCHID);
    //   this.get({
    //     url:'getPlaceid',
    //     data:{
    //       batchid:this.gwbbData.BATCHID
    //     }
    //   },(res)=>{
    //     console.log(res);
    //     console.log(999);
    //     if(res.code==200){
    //       this.places=res.data
    //     }
    //   })
    // }
  },

  created(){
   
  },

  

 
}
</script>



<style scoped>



.messages{
  overflow: hidden;
  background-color: #e3efff;
  width: 100%;
}

.ryjbxxTitle{
  width: 128px;
  height: 30px;
  background: #CC0000;
  border-radius: 15px;
  text-align: center;
  line-height: 30px;
  color: #FEFEFE;
  margin: 0 auto;
  font-size: 16px;
}

.remarks{
  font-size: 14px;
  color: red;
  font-weight: bold;
  text-align: center;
  background-color: #E3EFFF;
  border-bottom:1px solid #C1D7F9;
  padding: 15px;
}

.tzgg-title {
  border-radius: 5px 5px 0px 0px;
  height: 39px;
  line-height: 39px;
  text-align: center;
  max-width: 275px;
  padding-left: 20px;
  padding-right: 20px;
  -webkit-border-radius: 5px 5px 0px 0px;
  -moz-border-radius: 5px 5px 0px 0px;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 10px;
  cursor: pointer;
}

.adds{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  font-size: 16px;
}

.adds div:hover{
  cursor: pointer;
}

.adds button:hover{
  cursor: pointer;
}

.adds div{
  width: 25px;
  height: 25px;
  background-color: #c00000;
  border-radius: 50%;
  text-align: center;
  line-height: 25px;
  color: white;
  font-weight: blod;
  margin-right: 5px;
} 

.adds button{
  background-color: #E3EFFF;
  color: #c00000;
  border:none;
  font-size: 16px;
}

.dialogFooter{
  background-color: #e3efff;
  border: 1px solid #c1d7f9;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btnStyle1{
  width: 84px;
  height: 36px;
  background-color: #f1a338;
  font-size: 16px;
  line-height: 36px;
  text-align: center;
  color: #fff;
  border: none;
  border-radius: 3px;
  margin: 10px 5px;
}

.btnStyle1:hover{
  cursor:pointer;
}


.cm{
  position: absolute;
  bottom: -10px;
  left: 200px;
}
.kg{
  position: absolute;
  bottom: -10px;
  left: 199px;
}

.bigBox{
  max-height:600px;
  overflow:scroll;
  padding-bottom:30px;
   overflow-X:hidden;
}


/deep/ .ant-table-tbody > tr > td {
  padding: 5px;
  height: 38px;
}

/* 这里设置了表头颜色，不知道什么没有生效 */

/deep/ .ant-table-thead{
  background-color: #FFE5E5!important;
}

/deep/ .ant-table-pagination.ant-pagination {
    float: left;
}

/deep/ .ant-table-tbody{
  background-color: #fff;
}

/deep/ .ant-modal-content{
  width: 720px!important;
}

/deep/ .ant-btn-primary{
  color: #1890ff;
  background-color: white;
  border-color: white;
  box-shadow: none;
}

/deep/ .ant-table-row {
  padding: 5px 0!important;
}

/deep/ th{
  text-align: center!important;
  border-top: 1px solid rgb(230, 224, 224);
}

/deep/ .ant-form-item-control{
  text-align: center;
}

/deep/ .ant-modal-content th{
  text-align: center!important;
  padding: 0px 10px !important;
}


/deep/ .ant-col{
  height: 60px!important;
  font-size: 16px!important;
}

/* /deep/ .ant-table-body {

} */

/deep/ .txtarea .ant-form-item-control{
  width: 506px!important;
}

.txtarea{
  margin-bottom: 80px;
}


input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
     -webkit-appearance: none;
}

input[type="number"] {
      -moz-appearance: textfield;
}

/deep/ .ant-table-tbody > tr > td {
  background-color: #fff;
  text-align: center !important;
  padding: 5px 3px !important; ;
  max-width: 70px;
  white-space:nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/deep/ .ant-modal-content td{
  text-align: center!important;
  padding: 0px 0px !important;
  width: 80px!important;
}

/deep/ .ant-table-row-cell-last{
  width: 92px!important;
}
</style>


// WEBPACK FOOTER //
// src/views/zkzw/compos/gwbb.vue